// loggedinUser defaultLogin

import React, { useEffect, useLayoutEffect, useState } from "react";
import "./components/dashboard/dashboard.css";
import { ThemeProvider } from "@mui/material/styles";
import { dashboard } from "./components/theme/dashboard";
import RootRoutes from "./RootRoutes";
import UserContext from "./context/User";
import {
  getUserFullDetails,
  getUserToken,
  getUserTokenJWT,
  newUserToken,
} from "./utility/api/accounts";
import { isJwtExpired, refreshAuthTokens } from "./utility/auth/tokenRefresh";

import { useLocation, useNavigate } from "react-router";

// Application Insight Import
// ! Method 1
// import { getAppInsights } from "./azureConfig/TelemetryService";
// import TelemetryProvider from "./azureConfig/telemetry-provider";
// ! Method 2
import {
  withAITracking,
  AppInsightsContext,
} from "@microsoft/applicationinsights-react-js";
import { reactPlugin, appInsights } from "./azureConfig/AppInsights";
import { useDispatch } from "react-redux";
import { setRef } from "./redux/ref/action";
import { set } from "lodash";

var CryptoJS = require("crypto-js");

function App() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const username = searchParams.get("username");
  const password = searchParams.get("password");
  // let appInsights = null;

  const [userData, setUserData] = useState({});
  const [loaidngLogin, setLoadingLogin] = useState(false);
  const [defaultUser] = useState({
    username: process.env.REACT_APP_DEFAULT_USERNAME,
    password: process.env.REACT_APP_DEFAULT_PASSWORD,
  });

  useLayoutEffect(() => {
    console.log("Location", location);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  async function handleDefaultLogin() {
    var temp_get_token = {};
    var temp_get_details = {};
    // while : getUserToken -> temp_get_token
    var breaking_manually_1 = 0;
    while (true) {
      temp_get_token = await getUserToken(defaultUser);
      breaking_manually_1++;
      if (breaking_manually_1 === 10) {
        break;
      }
      if (temp_get_token.status) {
        break;
      }
    }

    // while : getUserFullDetails -> temp_get_details
    var breaking_manually_2 = 0;
    while (true) {
      temp_get_details = await getUserFullDetails(
        temp_get_token.response.jwtToken,
        defaultUser
      );
      breaking_manually_2++;
      if (breaking_manually_2 === 10) {
        break;
      }
      if (temp_get_details.status) {
        break;
      }
    }

    localStorage.setItem("defaultToken", temp_get_token.response.jwtToken);
    // Encrypt the default user data
    var ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify({
        ...defaultUser,
        token: temp_get_token.response.jwtToken,
        message: "Deault Login Successfull",
        isLoggedIn: true,
        fullDetails: temp_get_details.response,
      }),
      process.env.REACT_APP_CRYPTING_KEY
    ).toString();

    localStorage.setItem("defaultToken", temp_get_token.response.jwtToken);
    localStorage.setItem("defLoginCrypt", ciphertext);

    setUserData((prev) => {
      return {
        ...prev,
        defaultLogin: {
          ...prev.defaultLogin,
          ...defaultUser,
          token: temp_get_token.response.jwtToken,
          message: "Deault Login Successfull",
          isLoggedIn: true,
          fullDetails: temp_get_details.response,
        },
      };
    });
  }

  async function handleLogin(userloginDetail) {
    var loggedinUser = {
      ...userloginDetail,
      isLoggedIn: false,
    };

    console.log("userloginDetail", userloginDetail, userData);

    if (userData?.defaultLogin?.isLoggedIn) {
      var temp_get_token = {};
      var temp_get_details = {};
      var new_token = await newUserToken({
        email: process.env.REACT_APP_EMAIL,
        password: process.env.REACT_APP_PASSWORD,
      });
      console.log("TOKEN NEW!!", new_token?.response?.authToken);
      localStorage.setItem("apiToken", new_token?.response?.authToken);
      temp_get_token = await getUserTokenJWT(
        userloginDetail,
        userData?.defaultLogin?.token
      );
      if (temp_get_token.status) {
        temp_get_details = await getUserFullDetails(
          userData.defaultLogin.token,
          userloginDetail
        );
        if (temp_get_details.status) {
          // Loggedin user token
          localStorage.setItem("jwtToken", temp_get_token.response.jwtToken);
          // Logged In Status
          localStorage.setItem("loggedIn", true);

          // User status
          // active means authorized to access dashboard
          // new means not authorized to access dashboard and yet to be approved
          localStorage.setItem(
            "dashboard_status",
            temp_get_details.response.status
          );

          loggedinUser = {
            ...userloginDetail,
            token: temp_get_token.response.jwtToken,
            message: "Deault Login Successfull",
            isLoggedIn: true,
            fullDetails: temp_get_details.response,
            newToken: new_token.response.authToken,
          };

          // Encrypt the default user data
          var ciphertext = CryptoJS.AES.encrypt(
            JSON.stringify({ ...loggedinUser }),
            process.env.REACT_APP_CRYPTING_KEY
          ).toString();

          localStorage.setItem(
            "defaultToken",
            temp_get_token.response.jwtToken
          );
          localStorage.setItem("oldLoginCrypt", ciphertext);

          setUserData((prev) => ({
            ...prev,
            loggedinUser: {
              ...prev.loggedinUser,
              ...loggedinUser,
            },
          }));
        } else {
          loggedinUser = {
            ...userloginDetail,
            message: temp_get_token.message,
            messageCode: temp_get_token.messageCode,
            code: temp_get_token.code,
            isLoggedIn: false,
            fullDetails: {},
          };
          setUserData((prev) => ({
            ...prev,
            loggedinUser: {
              ...prev.loggedinUser,
              ...loggedinUser,
            },
          }));
        }
      } else {
        loggedinUser = {
          ...userloginDetail,
          message: temp_get_token.message,
          messageCode: temp_get_token.messageCode,
          code: temp_get_token.code,
          isLoggedIn: false,
          fullDetails: {},
        };
        setUserData((prev) => ({
          ...prev,
          loggedinUser: {
            ...prev.loggedinUser,
            ...loggedinUser,
          },
        }));
      }
    }

    return loggedinUser;
  }

  async function handleLogout() {
    localStorage.setItem("jwtToken", "");
    localStorage.setItem("oldLoginCrypt", "");
    localStorage.setItem("loggedIn", false);
    localStorage.setItem("dashboard_status", "");
    localStorage.setItem("firstName", "");
    localStorage.setItem("userOrganisation", "");
    localStorage.setItem("userDetails", "");
    localStorage.setItem("apiToken", "");
    localStorage.setItem("defLoginCrypt", "");
    localStorage.setItem("isHideAppbar", false);
    dispatch(setRef(null));

    setUserData((prev) => ({
      ...prev,
      loggedinUser: {},
    }));

    navigate("/");
  }

  async function automatedLogin() {
    let defLoginCrypt = {
      status: false,
      data: await localStorage.getItem("defLoginCrypt"),
      conv: {},
    };
    let oldLoginCrypt = {
      status: false,
      data: await localStorage.getItem("oldLoginCrypt"),
      conv: {},
    };

    // defLoginCrypt oldLoginCrypt
    if (defLoginCrypt.data) {
      // defLoginCrypt
      try {
        let bytes = CryptoJS.AES.decrypt(
          defLoginCrypt.data,
          process.env.REACT_APP_CRYPTING_KEY
        );
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        defLoginCrypt["conv"] = { ...decryptedData };
        defLoginCrypt["status"] = true;
      } catch {}

      // oldLoginCrypt
      if (oldLoginCrypt.data) {
        try {
          let bytes = CryptoJS.AES.decrypt(
            oldLoginCrypt.data,
            process.env.REACT_APP_CRYPTING_KEY
          );
          let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          oldLoginCrypt["conv"] = { ...decryptedData };
          oldLoginCrypt["status"] = true;

          // Restore apiToken and jwtToken to localStorage for consistent API access
          if (decryptedData.newToken) {
            localStorage.setItem("apiToken", decryptedData.newToken);
          }
          if (decryptedData.token) {
            localStorage.setItem("jwtToken", decryptedData.token);
          }

          // If the restored token is already expired, refresh it silently now
          // (using the stored credentials) so the user isn't bounced to login.
          if (isJwtExpired(decryptedData.token)) {
            try {
              const refreshed = await refreshAuthTokens();
              if (refreshed?.jwtToken) {
                decryptedData.token = refreshed.jwtToken;
                oldLoginCrypt["conv"] = { ...decryptedData };
              }
            } catch {}
          }
        } catch {}
      }

      console.log("this si sauto aloaded");
    } else {
      localStorage.setItem("jwtToken", "");
      localStorage.setItem("defLoginCrypt", "");
      localStorage.setItem("oldLoginCrypt", "");
      localStorage.setItem("loggedIn", false);
      await handleDefaultLogin();
    }

    if (defLoginCrypt.status && oldLoginCrypt.status) {
      setUserData((prev) => {
        return {
          ...prev,
          defaultLogin: { ...defLoginCrypt["conv"] },
          loggedinUser: { ...oldLoginCrypt["conv"] },
        };
      });

      try {
        if (
          window.location.pathname === "/" ||
          window.location.pathname === "/login"
        ) {
          navigate("/api-align");
        }
      } catch (err) {
        setTimeout(() => {
          if (
            window.location.pathname === "/" ||
            window.location.pathname === "/login"
          ) {
            navigate("/api-align");
          }
        }, 2000);
      }
    } else if (defLoginCrypt.status) {
      setUserData((prev) => {
        return {
          ...prev,
          defaultLogin: { ...defLoginCrypt["conv"] },
        };
      });
    }
  }

  const isDefaultLoginReady = userData.defaultLogin?.isLoggedIn;
  const isCurrentlyLoading = userData.isLoading;
  const fetchAppbarLogin = async () => {
    const details = {
      username: username,
      password: password,
    };

    console.log("is this calling", details);

    if (username && password) {
      console.warn(
        "SECURITY WARNING: Detected login credentials in URL parameters. This is highly insecure!"
      );

      setLoadingLogin(true);

      // if (isDefaultLoginReady && !isCurrentlyLoading) {
      const loginData = await handleLogin(details);

      if (loginData?.isLoggedIn) {
        console.log("Login successful", loginData);
        localStorage.setItem("userDetails", JSON.stringify(loginData));
        dispatch(setRef("/bian_portal_v1"));
        localStorage.setItem("isHideAppbar", true);
        setLoadingLogin(false);
        navigate("/api-align", { replace: true });
      } else {
        console.error("Login failed", loginData);
        dispatch(setRef(null));
        navigate("/", { replace: true });
      }
      // }
    }
  };

  useEffect(() => {
    if (userData?.loggedinUser?.isLoggedIn) {
      console.log("🎭🎭🎭🎭", userData);
      localStorage.setItem(
        "userDetails",
        JSON.stringify(userData?.loggedinUser)
      );
      localStorage.setItem(
        "userOrganisation",
        JSON.stringify(userData?.loggedinUser?.fullDetails?.organisation)
      );
    }
  }, [userData?.loggedinUser]);

  useEffect(() => {
    automatedLogin();
    // fetchAppbarLogin();
  }, []);

  useEffect(() => {
    if (userData?.defaultLogin?.isLoggedIn) {
      fetchAppbarLogin();
    }
  }, [userData?.defaultLogin?.isLoggedIn]);

  // !Normal without azureConfig
  // return (
  // 	<TelemetryProvider
  // 		instrumentationKey={process.env.REACT_APP_AZURE_INSTRUMENTATION_KEY}
  // 		after={() => {
  // 			appInsights = getAppInsights();
  // 		}}
  // 	>
  // 		<ThemeProvider theme={dashboard}>
  // 			<UserContext.Provider
  // 				value={{
  // 					...userData,
  // 					handleLogin,
  // 					handleLogout,
  // 				}}
  // 			>
  // 				<RootRoutes />
  // 			</UserContext.Provider>
  // 		</ThemeProvider>
  // 	</TelemetryProvider>
  // );
  // ! Method 1 azureConfig
  // return (
  // 	<ThemeProvider theme={dashboard}>
  // 		<UserContext.Provider
  // 			value={{
  // 				...userData,
  // 				handleLogin,
  // 				handleLogout,
  // 			}}
  // 		>
  // 			<RootRoutes />
  // 		</UserContext.Provider>
  // 	</ThemeProvider>
  // );
  // ! Method 2 azureConfig
  return (
    <section data-test-id="app-1">
      <AppInsightsContext.Provider value={reactPlugin}>
        <ThemeProvider theme={dashboard}>
          <UserContext.Provider
            value={{
              ...userData,
              handleLogin,
              handleLogout,
            }}
          >
            <RootRoutes fallback={loaidngLogin} />
          </UserContext.Provider>
        </ThemeProvider>
      </AppInsightsContext.Provider>
    </section>
  );
}

// export default App;
export default withAITracking(reactPlugin, App);
